import { apiClient } from '.';

// 커피챗 큐레이션 관련 타입 정의
export interface CoffeeChatPerson {
  section_related_person_id: number;
  person_id: number;
  name: string;
  department: string;
  image_url: string;
  tags: string[];
}

export interface CoffeeChatCurationSection {
  coffee_chat_section_id: number;
  title: string;
  text: string;
  related_persons: CoffeeChatPerson[];
}

export interface CoffeeChatCurationsResponse {
  code: number;
  status: string;
  message: string;
  data: CoffeeChatCurationSection[];
}

// 커피챗 큐레이션 API 함수
export const fetchCoffeeChatCurations = async (): Promise<CoffeeChatCurationsResponse> => {
  try {
    const response = await apiClient.get<CoffeeChatCurationsResponse>('/api/ui/coffee-chat/curations/persons/list');
    return response.data;
  } catch (error) {
    /// console.error('커피챗 큐레이션 데이터 로딩 실패:', error);
    throw error;
  }
};

// 관리자용 커피챗 큐레이션 섹션 생성
export const createCoffeeChatCurationSection = async (data: { title: string; text: string }): Promise<void> => {
  await apiClient.post('/api/ui/coffee-chat/curations', data);
};

// 관리자용 커피챗 큐레이션 섹션 수정
export const updateCoffeeChatCurationSection = async (sectionId: number, data: { title: string; text: string }): Promise<void> => {
  await apiClient.put(`/api/ui/coffee-chat/curations/${sectionId}`, data);
};

// 관리자용 커피챗 큐레이션 섹션 삭제
export const deleteCoffeeChatCurationSection = async (sectionId: number): Promise<void> => {
  await apiClient.delete(`/api/ui/coffee-chat/curations/${sectionId}`);
};

// 커피챗 큐레이션 섹션에 연자(멘토) 연결
export const addPersonToCoffeeChatCuration = async (sectionId: number, personId: number): Promise<void> => {
  await apiClient.post(`/api/ui/coffee-chat/curations/${sectionId}/persons/${personId}`);
};

// 커피챗 큐레이션 섹션에서 연자(멘토) 연결 해제
export const removePersonFromCoffeeChatCuration = async (sectionId: number, personId: number): Promise<void> => {
  await apiClient.delete(`/api/ui/coffee-chat/curations/${sectionId}/persons/${personId}`);
};

// 데이터 검증 헬퍼 함수
export const validateCoffeeChatPerson = (person: any): CoffeeChatPerson => {
  return {
    section_related_person_id: Number(person?.section_related_person_id || 0),
    person_id: Number(person?.person_id || 0),
    name: String(person?.name || ''),
    department: String(person?.department || ''),
    image_url: person?.image_url ? String(person.image_url) : '',
    tags: Array.isArray(person?.tags) ? person.tags : (person?.tags ? [person.tags] : [])
  };
};

export const validateCoffeeChatCurationSection = (section: any): CoffeeChatCurationSection => {
  return {
    coffee_chat_section_id: Number(section?.coffee_chat_section_id || 0),
    title: String(section?.title || ''),
    text: String(section?.text || ''),
    related_persons: Array.isArray(section?.related_persons) 
      ? section.related_persons.map(validateCoffeeChatPerson)
      : []
  };
};
